import React, { useState } from 'react';
import InputTitleView from './InputTitleView';
import { useIntl } from 'react-intl';
import IntlMessages from 'Util/IntlMessages';
import AddressNewPopup from 'Components/Popup/AddressNewPopup';

const AddressInputView = ({ address, address2, onChange }) => {
  const { formatMessage } = useIntl();
  const [openAddressPopup, setOpenAddressPopup] = useState(false);
  return (
    <>
      <div className="recruitment-address-input-view">
        <InputTitleView title={formatMessage({ id: 'common.address' })} required={false} subTitle="" />
        <div className={`recruitment-address-input-view-address-wrapper`}>
          <div className="address-title">{address ? <span>{address}</span> : <IntlMessages id="common.address" />}</div>
          <div className="search-button" onClick={() => setOpenAddressPopup(true)}>
            <IntlMessages id="button.search" />
          </div>
        </div>
        <div className={`recruitment-address-input-view-input-wrapper`} style={{ marginLeft: '10px', paddingLeft: '0px' }}>
          <input type="text" placeholder={formatMessage({ id: 'recruitment.address2' })} value={address2} onChange={({ target: { value } }) => onChange({ businessAddress2: value })} />
        </div>
      </div>
      <AddressNewPopup
        open={openAddressPopup}
        onClose={() => setOpenAddressPopup(false)}
        onSelect={item => {
          onChange({
            businessAddress: item.address,
            businessAddress2: item.address2,
            latitude: item.latitude,
            longitude: item.longitude,
          });
        }}
      />
    </>
  );
};

export default AddressInputView;
